export default __webpack_public_path__ + "static/media/design.9a3754ed.svg";